<div class="modal-header">
  <p class="modal-title pull-left" [innerHTML]="title"></p>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
    <p style="font-size: 14px;">Show data where :</p>
    <p *ngIf="content" class="data-header"><span>{{content.FilterOptionDisplay}}</span></p>
  <div class="dropdown-control">
    <ng-select #filter class="custom-dropdown" style="margin-right: 10px;"
      [searchable]="true"
      [clearable]="false"
      [(ngModel)]="option.SelectedItem">
      <ng-option *ngFor="let opt of optionList" [value]="opt.ItemValue" [title]="opt.ItemDisplay">
        {{opt.ItemDisplay }}
      </ng-option>
    </ng-select>
  </div>
  <div *ngIf="content" class="dropdown-control">
    <!-- <ng-select #filter
      [clearable]="false" 
      [searchable]="true"
      placeholder="Select filter"
      [(ngModel)]="content.SelectedFilterItem"
      dropdownPosition="auto">
      <ng-option *ngFor="let opt of content.FilterOptionItems" [value]="opt.ItemValue" [title]="opt.ItemDisplay">
        {{opt.ItemDisplay }}
      </ng-option>
    </ng-select> -->
    <input #text [(ngModel)]="inputText" type="text" [ngClass]="{'form-control': true, 'invalid': isInputEmpty}" placeholder="Type filter value" (change)="onChange()" [value]="inputValue" (keyup.enter)="enter(text.value)">
    <span></span>
    <div *ngIf="isInputEmpty" class="invalid-feedback" style="display:block">
      <div>Value is required</div>
    </div>
    <div class=""></div>
  </div>
  <div class="clearfix"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-respond CANCEL" (click)="clearFilter()">CLEAR</button>
  <ng-container *ngIf="options.length">
    <button *ngFor="let option of options" type="button" class="btn btn-primary btn-respond {{option}}" (click)="respond(option)">{{option}}</button>
  </ng-container>
</div>
  